import React from "react";
import { Link } from "gatsby";
import GeneralAnchor from "../general-anchor/general-anchor.component";
import './_application-guide.styles.scss';

const ApplicationGuide = () => (
  <div className="application-guide">
    <div>
      <h2>Application Help Centre</h2>
      <p>For detailed guidance and support with keying the application, please visit our{" "}
        <Link
          className="inline-link"
          to="/application-help-centre"
        >
          Application Help Centre
        </Link>.</p>
    </div>
    <GeneralAnchor isRed href="/application-help-centre">
      Find out more
    </GeneralAnchor>
  </div>
);

export default ApplicationGuide;
